module.exports = __webpack_public_path__ + "img/total-expanse.096fe927.svg";